// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rmaReceiveLabelConstants } from "@guestsupply/App/Widgets/RequestRma/RequestRmaReceiveLabel";
import {
    rmaReturnCustomerInformationFieldsModel,
    rmaReturnInformationModel,
} from "@guestsupply/App/Widgets/RequestRma/RequestRmaReturnInformation";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type RmaReturnInformationStateModel = {
    properties: rmaReturnInformationModel;
};

const initialState: RmaReturnInformationStateModel = {
    properties: {
        [rmaReceiveLabelConstants.customerInformation]: {},
        [rmaReceiveLabelConstants.upsReturnLabel]: "Email",
        [rmaReceiveLabelConstants.email]: "",
        [rmaReceiveLabelConstants.replacement]: false,
    },
};

const xRmaReturnInformation = createTypedReducerWithImmer(initialState, {
    "xRmaReturnInformation/SetRmaReturnInformation": (
        draft: Draft<RmaReturnInformationStateModel>,
        action: { customerInformation: rmaReturnCustomerInformationFieldsModel },
    ) => {
        draft.properties.customerInformation = action.customerInformation!;
    },
    "xRmaReturnInformation/SetRmaUPSReturnLabel": (
        draft: Draft<RmaReturnInformationStateModel>,
        action: { UPSReturnLabel: string },
    ) => {
        draft.properties.UPSReturnLabel = action.UPSReturnLabel!;
    },
    "xRmaReturnInformation/SetRmaProductImage": (
        draft: Draft<any>,
        action: { productImage: string; name: string; productImageId: string },
    ) => {
        draft.properties[action.name] = action?.productImage;
    },
    "xRmaReturnInformation/RemoveRmaProductImages": (draft: Draft<any>, action: { productImageId: string }) => {
        for (const key in draft.properties) {
            if (key.includes(action.productImageId)) {
                delete draft.properties[key];
            }
        }
    },
    "xRmaReturnInformation/SetRmaEmail": (
        draft: Draft<RmaReturnInformationStateModel>,
        action: { RMAEmail: string },
    ) => {
        draft.properties.RMAEmail = action.RMAEmail;
    },
    "xRmaReturnInformation/SetRmaReturnReplacement": (
        draft: Draft<RmaReturnInformationStateModel>,
        action: { RMAReplacement: boolean },
    ) => {
        draft.properties.RMAReplacement = action.RMAReplacement;
    },
});

(reducers as any).xRmaReturnInformation = xRmaReturnInformation;

export type xRmaReturnInformation = {
    xRmaReturnInformation: RmaReturnInformationStateModel;
} & ApplicationState;

type RmaReturnInformationReducer = {
    rmaReturnInformation: typeof xRmaReturnInformation;
};

export type RmaReturnInformationActions =
    | Parameters<RmaReturnInformationReducer[keyof RmaReturnInformationReducer]>[1]
    | AnyAction;
